import { BEGIN, COMMIT, REVERT } from 'redux-optimist';
import uuid from 'uuid/v4';

export default () => next => async action => {
  const { optimistic, ...restActionFields } = action;
  const isPromise = optimistic instanceof Promise;
  const isFunction = optimistic instanceof Function;

  if (!(isPromise || isFunction)) {
    return next(action);
  }

  const transactionID = uuid();

  next({
    ...restActionFields,
    type: `${action.type}_OPTIMISTIC`,
    optimist: { type: BEGIN, id: transactionID },
  });

  try {
    await (isFunction ? optimistic() : optimistic);

    next({
      type: `${action.type}_SUCCEEDED`,
      optimist: { type: COMMIT, id: transactionID },
    });
  } catch (error) {
    if (error.name === 'AbortError') {
      next({
        type: `${action.type}_ABORTED`,
        optimist: { type: REVERT, id: transactionID },
      });
    } else {
      next({
        type: `${action.type}_FAILED`,
        payload: error,
        error: true,
        optimist: { type: REVERT, id: transactionID },
      });
    }
  }
};
